import React from 'react';
import BasePage from './BasePage';
import { connect } from 'react-redux';
import { setModalContent } from '../actionCreators';
import Menu from '../components/Menu';
import Modal from '../components/Modal';
import ServidorAeatInfo from '../components/ServidorAeatInfo';
import $ from 'jquery';

function prettyXml(xmlStr) {
    if (!xmlStr) return '';
    try {
        const PAD = '  ';
        let pad = 0;
        const lines = xmlStr.replace(/(>)(<)(\/*)/g, '$1\n$2$3').split('\n');
        return lines.map(raw => {
            const node = raw.trim();
            if (!node) return '';
            const isClose    = /^<\/\w/.test(node);
            const isSelfClose = /\/>$/.test(node) || /^<\?/.test(node);
            const isOpen     = !isClose && !isSelfClose && /^<\w/.test(node);
            const isInline   = /^<\w[^>]*>[^<]+<\/\w/.test(node);
            if (isClose) pad = Math.max(0, pad - 1);
            const line = PAD.repeat(pad) + node;
            if (isOpen && !isInline) pad++;
            return line;
        }).filter(Boolean).join('\n');
    } catch(e) { return xmlStr; }
}

function todayStr() {
    const d = new Date();
    return d.toISOString().slice(0, 10);
}

function daysAgoStr(n) {
    const d = new Date();
    d.setDate(d.getDate() - n);
    return d.toISOString().slice(0, 10);
}

const STATUS_LABELS = {
    pending:            { label: 'Pendiente',         bg: '#fef9c3', color: '#713f12', border: '#fde047' },
    processing:         { label: 'Procesando',        bg: '#dbeafe', color: '#1e3a5f', border: '#93c5fd' },
    retrying:           { label: 'Reintentando',      bg: '#ffedd5', color: '#7c2d12', border: '#fb923c' },
    done:               { label: 'Correcto',          bg: '#dcfce7', color: '#14532d', border: '#86efac' },
    permanently_failed: { label: 'Fallo permanente',  bg: '#fee2e2', color: '#7f1d1d', border: '#f87171' },
    aeat_rechazado:     { label: 'Rechazado AEAT',    bg: '#fdf2f8', color: '#831843', border: '#f9a8d4' },
};

function StatusBadge({ status }) {
    const cfg = STATUS_LABELS[status] || { label: status, bg: '#f3f4f6', color: '#374151', border: '#d1d5db' };
    return (
        <span style={{
            display: 'inline-block', padding: '2px 10px', borderRadius: '12px', fontSize: '12px',
            fontWeight: 600, background: cfg.bg, color: cfg.color,
            border: '1px solid ' + cfg.border
        }}>
            {cfg.label}
        </span>
    );
}

function StatCard({ label, value, bg, color }) {
    return (
        <div style={{
            background: bg, border: '1px solid ' + color + '44',
            borderRadius: '10px', padding: '16px 20px', minWidth: '120px', flex: 1,
            textAlign: 'center'
        }}>
            <div style={{ fontSize: '28px', fontWeight: 700, color }}>{value}</div>
            <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '2px' }}>{label}</div>
        </div>
    );
}

class VerifactuAdmin extends BasePage {

    loadOnConstructor() {
        this.loadDashboard = this.loadDashboard.bind(this);
        this.loadActividad = this.loadActividad.bind(this);
        this.handleFlush = this.handleFlush.bind(this);
        this.handleReencolar = this.handleReencolar.bind(this);
        this.handleVerXml = this.handleVerXml.bind(this);
        this.handleActividadFiltrar = this.handleActividadFiltrar.bind(this);
        this.formatDate = this.formatDate.bind(this);

        this.handleEnvioManual = this.handleEnvioManual.bind(this);
        this.handleAnularEnVerifactu = this.handleAnularEnVerifactu.bind(this);

        this.state = {
            activeTab: 'actividad',
            // Actividad tab
            actividadLoading: true,
            actividadItems: [],
            actividadError: null,
            actividadFechaDesde: daysAgoStr(30),
            actividadFechaHasta: todayStr(),
            // Estado tab
            loading: false,
            stats: null,
            pendientes: [],
            recientes: [],
            health: null,
            error: null,
            // XML viewer modal
            xmlModal: null,
            // Envío manual modal
            envioManualOpen: false,
            envioManualXml: '',
            envioManualSending: false,
            envioManualResult: null,
        };

        this.loadActividad();
    }

    loadActividad() {
        const { actividadFechaDesde, actividadFechaHasta } = this.state;
        this.setState({ actividadLoading: true, actividadError: null });
        const api = this.getApi();
        api.getVerifactuActividad(actividadFechaDesde, actividadFechaHasta, (response) => {
            if (response.status === 'OK') {
                this.setState({ actividadLoading: false, actividadItems: response.items || [] });
            } else {
                this.setState({ actividadLoading: false, actividadError: response.message || 'Error cargando actividad' });
            }
        });
    }

    loadDashboard() {
        this.setState({ loading: true, error: null });
        const api = this.getApi();
        api.getVerifactuDashboard((response) => {
            if (response.status === 'OK') {
                this.setState({
                    loading: false,
                    stats: response.stats,
                    pendientes: response.pendientes || [],
                    recientes: response.recientes || [],
                    health: response.health || null
                });
            } else {
                this.setState({ loading: false, error: response.message || 'Error cargando datos' });
            }
        });
    }

    handleFlush() {
        const api = this.getApi();
        api.verifactuFlush((response) => {
            this.props.setModalContent({
                title: 'Worker de cola',
                body: [response.status === 'OK' ? 'Worker iniciado correctamente.' : (response.message || 'Error al iniciar el worker.')],
                buttons: [{ shown: 'Aceptar', behaviour: 'main', close: true, callback: () => { this.loadActividad(); if (this.state.activeTab === 'estado') this.loadDashboard(); } }]
            });
            $('#exampleModal').modal('toggle');
        });
    }

    handleReencolar(queueId) {
        const api = this.getApi();
        api.verifactuAdminReencolar(queueId, (response) => {
            this.props.setModalContent({
                title: 'Reencolar',
                body: [response.status === 'OK' ? 'Item reencolado y worker iniciado.' : (response.message || 'Error al reencolar.')],
                buttons: [{ shown: 'Aceptar', behaviour: 'main', close: true, callback: () => { this.loadActividad(); if (this.state.activeTab === 'estado') this.loadDashboard(); } }]
            });
            $('#exampleModal').modal('toggle');
        });
    }

    handleVerXml(queueId) {
        const api = this.getApi();
        api.getVerifactuQueueXml(queueId, (response) => {
            if (response.status === 'OK') {
                this.setState({ xmlModal: { queueId, xml_sent: response.xml_sent, xml_received: response.xml_received, queue_status: response.queue_status, servidor_aeat: response.servidor_aeat, tab: 'sent' } });
            } else {
                alert(response.message || 'Error cargando XML');
            }
        });
    }

    handleAnularEnVerifactu(billId, billCode) {
        this.props.setModalContent({
            title: 'Anular en Verifactu',
            body: [
                `Se enviará un registro de anulación a la AEAT para la factura ${billCode}.`,
                'La factura quedará marcada como anulada cuando la AEAT confirme. El registro se conserva para consulta.'
            ],
            buttons: [
                { shown: 'Anular en Verifactu', behaviour: 'main', close: true, callback: () => {
                    const api = this.getApi();
                    api.verifactuAnular(billId, (response) => {
                        setTimeout(() => {
                            this.props.setModalContent({
                                title: response.status === 'OK' ? 'Anulación encolada' : 'No se ha podido encolar la anulación',
                                body: [response.message || (response.status === 'OK' ? 'Anulación añadida a la cola.' : 'Error desconocido')],
                                buttons: [{ shown: 'Aceptar', behaviour: 'main', close: true, callback: () => this.loadActividad() }]
                            });
                            $('#exampleModal').modal('toggle');
                        }, 400);
                    });
                }},
                { shown: 'Cancelar', close: true }
            ]
        });
        $('#exampleModal').modal('toggle');
    }

    handleEnvioManual() {
        const { envioManualXml } = this.state;
        if (!envioManualXml.trim()) return;
        this.setState({ envioManualSending: true, envioManualResult: null });
        const api = this.getApi();
        api.verifactuSendRawXml(envioManualXml.trim(), (response) => {
            this.setState({ envioManualSending: false, envioManualResult: response });
            // Refrescar actividad para que aparezca si se guardó algo
        });
    }

    handleActividadFiltrar(e) {
        e.preventDefault();
        this.loadActividad();
    }

    formatDate(dateStr) {
        if (!dateStr) return '—';
        const d = new Date(dateStr);
        return d.toLocaleDateString('es-ES') + ' ' + d.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });
    }

    renderXmlModal() {
        const { xmlModal } = this.state;
        if (!xmlModal) return null;
        return (
            <div style={{
                position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', zIndex: 9999,
                display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px'
            }} onClick={() => this.setState({ xmlModal: null })}>
                <div style={{
                    background: '#1e1e2e', borderRadius: '10px', width: '100%', maxWidth: '900px',
                    maxHeight: '85vh', display: 'flex', flexDirection: 'column', boxShadow: '0 20px 60px rgba(0,0,0,0.5)'
                }} onClick={e => e.stopPropagation()}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '14px 18px', borderBottom: '1px solid #313244' }}>
                        <span style={{ fontWeight: 700, color: '#cdd6f4', fontSize: '14px' }}>XML Verifactu</span>
                        <span style={{ fontFamily: 'monospace', fontSize: '11px', color: '#6c7086' }}>{xmlModal.queueId}</span>
                        <div style={{ marginLeft: 'auto', display: 'flex', gap: '6px' }}>
                            {['sent', 'received'].map(tab => (
                                <button key={tab}
                                    onClick={() => this.setState(s => ({ xmlModal: { ...s.xmlModal, tab } }))}
                                    style={{
                                        border: 'none', borderRadius: '6px', padding: '4px 14px', fontSize: '12px', cursor: 'pointer', fontWeight: 600,
                                        background: xmlModal.tab === tab ? '#89b4fa' : '#313244',
                                        color: xmlModal.tab === tab ? '#1e1e2e' : '#cdd6f4'
                                    }}>
                                    {tab === 'sent' ? 'Enviado' : 'Respuesta AEAT'}
                                </button>
                            ))}
                            <button onClick={() => this.setState({ xmlModal: null })}
                                style={{ border: 'none', background: '#313244', color: '#f38ba8', borderRadius: '6px', padding: '4px 10px', cursor: 'pointer', fontWeight: 700, fontSize: '13px' }}>
                                ✕
                            </button>
                        </div>
                    </div>
                    <div style={{ overflow: 'auto', flex: 1, padding: '16px' }}>
                        {xmlModal.tab === 'received' && xmlModal.xml_received &&
                            <ServidorAeatInfo servidor={xmlModal.servidor_aeat} />
                        }
                        {(xmlModal.tab === 'sent' ? xmlModal.xml_sent : xmlModal.xml_received)
                            ? <pre style={{ margin: 0, fontFamily: 'monospace', fontSize: '12px', color: '#cdd6f4', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                {prettyXml(xmlModal.tab === 'sent' ? xmlModal.xml_sent : xmlModal.xml_received)}
                              </pre>
                            : <div style={{ color: '#6c7086', textAlign: 'center', padding: '40px', fontSize: '13px' }}>
                                {['pending', 'processing', 'retrying'].includes(xmlModal.queue_status)
                                    ? 'El XML se generará cuando el worker procese este envío. Recarga en unos segundos.'
                                    : 'No disponible — este registro fue procesado antes de que se activara el guardado de XML'}
                              </div>
                        }
                    </div>
                    <div style={{ padding: '10px 18px', borderTop: '1px solid #313244', display: 'flex', justifyContent: 'flex-end' }}>
                        <button className="btn btn-sm btn-outline-secondary" style={{ fontSize: '12px', color: '#cdd6f4', borderColor: '#45475a' }}
                            onClick={() => {
                                const text = xmlModal.tab === 'sent' ? xmlModal.xml_sent : xmlModal.xml_received;
                                if (text) navigator.clipboard.writeText(text);
                            }}>
                            Copiar al portapapeles
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    renderEnvioManualModal() {
        const { envioManualOpen, envioManualXml, envioManualSending, envioManualResult } = this.state;
        if (!envioManualOpen) return null;

        const resultado = envioManualResult && envioManualResult.resultado;
        const esError = !envioManualResult || envioManualResult.status === 'KO';
        const estadoGlobal = resultado ? resultado.estadoGlobal : null;
        const estadoOk = estadoGlobal === 'Correcto' || estadoGlobal === 'ParcialmenteCorrecto';

        return (
            <div style={{
                position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 9998,
                display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px'
            }} onClick={() => this.setState({ envioManualOpen: false, envioManualResult: null })}>
                <div style={{
                    background: '#1e1e2e', borderRadius: '10px', width: '100%', maxWidth: '960px',
                    maxHeight: '90vh', display: 'flex', flexDirection: 'column',
                    boxShadow: '0 20px 60px rgba(0,0,0,0.6)'
                }} onClick={e => e.stopPropagation()}>

                    {/* Header */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '16px 20px', borderBottom: '1px solid #313244' }}>
                        <span style={{ fontWeight: 700, color: '#cdd6f4', fontSize: '15px' }}>Envío manual de XML a la AEAT</span>
                        <span style={{ fontSize: '12px', color: '#6c7086' }}>El XML se envía directamente sin pasar por la cola</span>
                        <button onClick={() => this.setState({ envioManualOpen: false, envioManualResult: null })}
                            style={{ marginLeft: 'auto', border: 'none', background: '#313244', color: '#f38ba8', borderRadius: '6px', padding: '4px 10px', cursor: 'pointer', fontWeight: 700, fontSize: '14px' }}>
                            ✕
                        </button>
                    </div>

                    <div style={{ display: 'flex', flex: 1, overflow: 'hidden', minHeight: 0 }}>
                        {/* Panel izquierdo: XML de entrada */}
                        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', borderRight: '1px solid #313244' }}>
                            <div style={{ padding: '10px 16px', borderBottom: '1px solid #313244', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <span style={{ fontSize: '12px', fontWeight: 600, color: '#89b4fa' }}>XML a enviar</span>
                                <button style={{ marginLeft: 'auto', border: 'none', background: '#313244', color: '#cdd6f4', borderRadius: '5px', padding: '2px 10px', cursor: 'pointer', fontSize: '11px' }}
                                    onClick={() => this.setState({ envioManualXml: '' })}>
                                    Limpiar
                                </button>
                            </div>
                            <textarea
                                value={envioManualXml}
                                onChange={e => this.setState({ envioManualXml: e.target.value, envioManualResult: null })}
                                placeholder={'Pega aquí el XML completo (<?xml version="1.0"...>)'}
                                style={{
                                    flex: 1, resize: 'none', border: 'none', outline: 'none',
                                    background: '#181825', color: '#cdd6f4', fontFamily: 'monospace',
                                    fontSize: '12px', padding: '14px 16px', lineHeight: '1.5',
                                    minHeight: '320px'
                                }}
                                spellCheck={false}
                            />
                            <div style={{ padding: '12px 16px', borderTop: '1px solid #313244', display: 'flex', gap: '8px', alignItems: 'center' }}>
                                <button
                                    onClick={this.handleEnvioManual}
                                    disabled={envioManualSending || !envioManualXml.trim()}
                                    style={{
                                        border: 'none', borderRadius: '7px', padding: '8px 22px',
                                        fontWeight: 700, fontSize: '13px', cursor: envioManualSending || !envioManualXml.trim() ? 'not-allowed' : 'pointer',
                                        background: envioManualSending || !envioManualXml.trim() ? '#45475a' : '#a6e3a1',
                                        color: envioManualSending || !envioManualXml.trim() ? '#6c7086' : '#1e1e2e',
                                    }}>
                                    {envioManualSending ? '⏳ Enviando...' : '▶ Enviar a la AEAT'}
                                </button>
                                {envioManualResult && !envioManualSending && (
                                    <span style={{ fontSize: '12px', color: esError ? '#f38ba8' : (estadoOk ? '#a6e3a1' : '#fab387') }}>
                                        {esError
                                            ? `✗ Error: ${envioManualResult.message}`
                                            : `${estadoOk ? '✓' : '⚠'} ${estadoGlobal}${resultado.csv ? ' — CSV: ' + resultado.csv : ''}`
                                        }
                                    </span>
                                )}
                                {envioManualResult && !envioManualSending && !esError && (
                                    <span style={{ fontSize: '11px', marginLeft: '4px', color: envioManualResult.logged ? '#a6e3a1' : '#f9e2af' }}>
                                        {envioManualResult.logged
                                            ? `· Registrado en ${envioManualResult.billCode}`
                                            : `· ${envioManualResult.logMessage || 'No registrado'}`
                                        }
                                    </span>
                                )}
                            </div>
                        </div>

                        {/* Panel derecho: respuesta AEAT */}
                        <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                            <div style={{ padding: '10px 16px', borderBottom: '1px solid #313244', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <span style={{ fontSize: '12px', fontWeight: 600, color: '#89b4fa' }}>Respuesta AEAT</span>
                                {resultado && resultado.errores && resultado.errores.length > 0 && (
                                    <span style={{ marginLeft: '8px', fontSize: '11px', color: '#f38ba8', background: '#3b1a1a', border: '1px solid #f38ba8', borderRadius: '4px', padding: '1px 7px' }}>
                                        {resultado.errores.length} error{resultado.errores.length > 1 ? 'es' : ''}
                                    </span>
                                )}
                                {resultado && resultado.xmlRaw && (
                                    <button style={{ marginLeft: 'auto', border: 'none', background: '#313244', color: '#cdd6f4', borderRadius: '5px', padding: '2px 10px', cursor: 'pointer', fontSize: '11px' }}
                                        onClick={() => { if (resultado.xmlRaw) navigator.clipboard.writeText(resultado.xmlRaw); }}>
                                        Copiar
                                    </button>
                                )}
                            </div>
                            <div style={{ flex: 1, overflow: 'auto', padding: '14px 16px', background: '#181825' }}>
                                {!envioManualResult && !envioManualSending && (
                                    <div style={{ color: '#45475a', textAlign: 'center', padding: '60px 20px', fontSize: '13px' }}>
                                        La respuesta de la AEAT aparecerá aquí
                                    </div>
                                )}
                                {envioManualSending && (
                                    <div style={{ color: '#6c7086', textAlign: 'center', padding: '60px 20px', fontSize: '13px' }}>
                                        Enviando a la AEAT...
                                    </div>
                                )}
                                {envioManualResult && !envioManualSending && (
                                    <>
                                        {resultado && resultado.errores && resultado.errores.length > 0 && (
                                            <div style={{ marginBottom: '12px', background: '#2a1a1a', border: '1px solid #f38ba8', borderRadius: '6px', padding: '10px 14px' }}>
                                                {resultado.errores.map((e, i) => (
                                                    <div key={i} style={{ color: '#f38ba8', fontSize: '12px', fontFamily: 'monospace' }}>{e}</div>
                                                ))}
                                            </div>
                                        )}
                                        {resultado && resultado.xmlRaw ? (
                                            <pre style={{ margin: 0, fontFamily: 'monospace', fontSize: '12px', color: '#cdd6f4', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                                {prettyXml(resultado.xmlRaw)}
                                            </pre>
                                        ) : (
                                            <div style={{ color: '#f38ba8', fontSize: '12px', fontFamily: 'monospace' }}>
                                                {envioManualResult.message || 'Sin respuesta XML'}
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderActividadTab() {
        const { actividadLoading, actividadItems, actividadError, actividadFechaDesde, actividadFechaHasta } = this.state;

        return (
            <div>
                {/* Filtro de fechas */}
                <form onSubmit={this.handleActividadFiltrar} style={{
                    display: 'flex', alignItems: 'flex-end', gap: '12px', flexWrap: 'wrap',
                    background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: '8px',
                    padding: '12px 16px', marginBottom: '20px'
                }}>
                    <div>
                        <label style={{ display: 'block', fontSize: '12px', fontWeight: 600, color: '#374151', marginBottom: '4px' }}>Desde</label>
                        <input type="date" className="form-control form-control-sm"
                            value={actividadFechaDesde}
                            onChange={e => this.setState({ actividadFechaDesde: e.target.value })}
                            style={{ width: '145px' }} />
                    </div>
                    <div>
                        <label style={{ display: 'block', fontSize: '12px', fontWeight: 600, color: '#374151', marginBottom: '4px' }}>Hasta</label>
                        <input type="date" className="form-control form-control-sm"
                            value={actividadFechaHasta}
                            onChange={e => this.setState({ actividadFechaHasta: e.target.value })}
                            style={{ width: '145px' }} />
                    </div>
                    <button type="submit" className="btn btn-primary btn-sm" style={{ borderRadius: '6px' }}
                        disabled={actividadLoading}>
                        {actividadLoading ? 'Cargando...' : 'Filtrar'}
                    </button>
                    <button type="button" className="btn btn-outline-secondary btn-sm" style={{ borderRadius: '6px' }}
                        onClick={() => this.setState({ actividadFechaDesde: '', actividadFechaHasta: '' }, this.loadActividad)}>
                        Sin filtro
                    </button>
                    <span style={{ marginLeft: 'auto', fontSize: '12px', color: '#9ca3af', alignSelf: 'center' }}>
                        {!actividadLoading && `${actividadItems.length} registros`}
                    </span>
                </form>

                {actividadError && <div className="alert alert-danger">{actividadError}</div>}

                {actividadLoading && <div style={{ textAlign: 'center', padding: '40px', color: '#6b7280' }}>Cargando...</div>}

                {!actividadLoading && actividadItems.length === 0 && (
                    <div style={{ background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: '8px', padding: '32px', textAlign: 'center', color: '#9ca3af' }}>
                        No hay registros en el período seleccionado
                    </div>
                )}

                {!actividadLoading && actividadItems.length > 0 && (
                    <div style={{ border: '1px solid #e5e7eb', borderRadius: '8px', overflow: 'hidden' }}>
                        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                            <thead>
                                <tr style={{ background: '#f9fafb', borderBottom: '1px solid #e5e7eb' }}>
                                    <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 600, color: '#374151' }}>Estado</th>
                                    <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 600, color: '#374151' }}>Tipo</th>
                                    <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 600, color: '#374151' }}>Factura</th>
                                    <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 600, color: '#374151' }}>Fecha envío</th>
                                    <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 600, color: '#374151' }}>Intentos</th>
                                    <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 600, color: '#374151' }}>Error / CSV</th>
                                    <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 600, color: '#374151' }}>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {actividadItems.map((item, i) => {
                                    const esRechazado = item._aeatRechazado;
                                    const esParcial = item._parcialCorrecto;
                                    const displayStatus = item.status === 'permanently_failed' ? 'permanently_failed'
                                        : esRechazado ? 'aeat_rechazado' : item.status;
                                    const errorMsg = esRechazado
                                        ? (item.result && item.result.errores ? item.result.errores.join('; ') : '—')
                                        : esParcial
                                            ? (item.result && item.result.errores && item.result.errores.length ? item.result.errores.join('; ') : 'Aceptado con avisos')
                                            : (item.status === 'permanently_failed' ? (item.lastError || '—') : '—');
                                    const csvMsg = item.result && item.result.csv ? item.result.csv : null;
                                    const rowBg = esRechazado ? '#fff8fb'
                                        : esParcial ? '#fffbeb'
                                        : item.status === 'permanently_failed' ? '#fff7f7'
                                        : item.status === 'done' ? '#f0fdf4'
                                        : '#fff';
                                    const canSeeXml = item.status === 'done' || item.status === 'permanently_failed';
                                    const canReencolar = !item.billAnulada && (item.status === 'permanently_failed' || (esRechazado && item._isLatestForBill));
                                    const canAnular = item._isAbsoluteLatestForBill && item.operacion === 'alta' && !item.billAnulada;

                                    return (
                                        <tr key={item._id} style={{
                                            borderBottom: i < actividadItems.length - 1 ? '1px solid #f3f4f6' : 'none',
                                            background: rowBg
                                        }}>
                                            <td style={{ padding: '10px 14px' }}><StatusBadge status={displayStatus} /></td>
                                            <td style={{ padding: '10px 14px', color: '#374151' }}>{item.operacion === 'alta' ? 'Alta' : 'Anulación'}</td>
                                            <td style={{ padding: '10px 14px' }}>
                                                {item.billCode
                                                    ? <a href={`/edit_bill?bill_id=${item.billId}`} style={{ fontWeight: 600, color: '#2563eb', textDecoration: 'none' }}>{item.billCode}</a>
                                                    : <span style={{ fontFamily: 'monospace', fontSize: '11px', color: '#6b7280' }}>{String(item.billId)}</span>
                                                }
                                            </td>
                                            <td style={{ padding: '10px 14px', color: '#6b7280', whiteSpace: 'nowrap' }}>
                                                {this.formatDate(item.createdAt)}
                                            </td>
                                            <td style={{ padding: '10px 14px', color: '#374151', textAlign: 'center' }}>
                                                {item.attempts || 0}
                                            </td>
                                            <td style={{ padding: '10px 14px', maxWidth: '240px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                                                title={errorMsg !== '—' ? errorMsg : undefined}>
                                                {errorMsg !== '—'
                                                    ? <span style={{ color: esRechazado ? '#dc2626' : esParcial ? '#92400e' : '#dc2626' }}>{errorMsg}</span>
                                                    : csvMsg
                                                        ? <span style={{ color: '#16a34a', fontFamily: 'monospace', fontSize: '11px' }}>{csvMsg}</span>
                                                        : <span style={{ color: '#d1d5db' }}>—</span>
                                                }
                                            </td>
                                            <td style={{ padding: '10px 14px' }}>
                                                <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                                                    {canSeeXml && (
                                                        <button className="btn btn-sm btn-outline-secondary"
                                                            style={{ borderRadius: '6px', fontSize: '11px', padding: '2px 8px' }}
                                                            onClick={() => this.handleVerXml(item._id)}>
                                                            Ver XML
                                                        </button>
                                                    )}
                                                    {canReencolar && (
                                                        <button className="btn btn-sm btn-warning"
                                                            style={{ borderRadius: '6px', fontSize: '11px', padding: '2px 8px', fontWeight: 600 }}
                                                            onClick={() => this.handleReencolar(item._id)}>
                                                            Reencolar
                                                        </button>
                                                    )}
                                                    {canAnular && (
                                                        <button className="btn btn-sm btn-danger"
                                                            style={{ borderRadius: '6px', fontSize: '11px', padding: '2px 8px', fontWeight: 600 }}
                                                            onClick={() => this.handleAnularEnVerifactu(item.billId, item.billCode)}>
                                                            Anular
                                                        </button>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        );
    }

    renderEstadoTab() {
        const { loading, stats, pendientes, recientes, health, error } = this.state;

        if (!stats && !loading) {
            return (
                <div style={{ textAlign: 'center', padding: '40px' }}>
                    <button className="btn btn-primary" onClick={this.loadDashboard}>Cargar estado</button>
                </div>
            );
        }

        return (
            <div>
                {loading && <div style={{ textAlign: 'center', padding: '40px', color: '#6b7280' }}>Cargando...</div>}
                {error && <div className="alert alert-danger">{error}</div>}

                {!loading && stats && <>
                    {/* Health */}
                    {health ? (
                        <div style={{
                            display: 'flex', alignItems: 'center', gap: '16px', flexWrap: 'wrap',
                            background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: '8px',
                            padding: '10px 16px', marginBottom: '20px', fontSize: '13px', color: '#374151'
                        }}>
                            <span style={{ fontWeight: 600 }}>Microservicio:</span>
                            <span style={{ color: '#16a34a', fontWeight: 600 }}>● Activo</span>
                            <span>NIF: <strong>{health.empresa}</strong></span>
                            <span>Entorno AEAT: <strong>{health.entorno || '—'}</strong></span>
                            {health.modoTest && <span style={{
                                background: '#fef9c3', color: '#713f12', border: '1px solid #fde047',
                                borderRadius: '6px', padding: '1px 8px', fontWeight: 600, fontSize: '11px'
                            }}>MODO TEST</span>}
                        </div>
                    ) : (
                        <div style={{
                            background: '#fee2e2', border: '1px solid #f87171', borderRadius: '8px',
                            padding: '10px 16px', marginBottom: '20px', fontSize: '13px', color: '#7f1d1d', fontWeight: 600
                        }}>
                            ⚠ No se puede conectar con el microservicio Verifactu
                        </div>
                    )}

                    {/* Stats */}
                    <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', marginBottom: '24px' }}>
                        <StatCard label="Pendientes"        value={stats.pending}            bg="#fef9c3" color="#713f12" />
                        <StatCard label="Procesando"        value={stats.processing}          bg="#dbeafe" color="#1e3a5f" />
                        <StatCard label="Reintentando"      value={stats.retrying}            bg="#ffedd5" color="#7c2d12" />
                        <StatCard label="Correctos"         value={stats.done}                bg="#dcfce7" color="#14532d" />
                        <StatCard label="Rechazados AEAT"   value={stats.aeat_rechazado || 0}
                            bg={stats.aeat_rechazado > 0 ? '#fdf2f8' : '#f9fafb'}
                            color={stats.aeat_rechazado > 0 ? '#831843' : '#9ca3af'} />
                        <StatCard label="Fallos permanentes" value={stats.permanently_failed}
                            bg={stats.permanently_failed > 0 ? '#fee2e2' : '#f9fafb'}
                            color={stats.permanently_failed > 0 ? '#7f1d1d' : '#9ca3af'} />
                    </div>

                    {/* Elementos que requieren atención */}
                    <div>
                        <h6 style={{ fontWeight: 600, color: '#374151', marginBottom: '8px' }}>
                            Elementos que requieren atención
                            {pendientes.length > 0 && <span style={{ marginLeft: '8px', background: '#fee2e2', color: '#7f1d1d', borderRadius: '10px', padding: '1px 8px', fontSize: '12px' }}>{pendientes.length}</span>}
                        </h6>
                        {pendientes.length === 0 ? (
                            <div style={{ background: '#f0fdf4', border: '1px solid #86efac', borderRadius: '8px', padding: '20px', textAlign: 'center', color: '#16a34a', fontWeight: 600 }}>
                                ✓ Cola limpia — no hay elementos pendientes ni fallidos
                            </div>
                        ) : (
                            <div style={{ border: '1px solid #e5e7eb', borderRadius: '8px', overflow: 'hidden' }}>
                                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                                    <thead>
                                        <tr style={{ background: '#f9fafb', borderBottom: '1px solid #e5e7eb' }}>
                                            <th style={{ padding: '10px 16px', textAlign: 'left', fontWeight: 600, color: '#374151' }}>Estado</th>
                                            <th style={{ padding: '10px 16px', textAlign: 'left', fontWeight: 600, color: '#374151' }}>Tipo</th>
                                            <th style={{ padding: '10px 16px', textAlign: 'left', fontWeight: 600, color: '#374151' }}>Factura</th>
                                            <th style={{ padding: '10px 16px', textAlign: 'left', fontWeight: 600, color: '#374151' }}>Intentos</th>
                                            <th style={{ padding: '10px 16px', textAlign: 'left', fontWeight: 600, color: '#374151' }}>Último error</th>
                                            <th style={{ padding: '10px 16px', textAlign: 'left', fontWeight: 600, color: '#374151' }}>Fecha</th>
                                            <th style={{ padding: '10px 16px', textAlign: 'left', fontWeight: 600, color: '#374151' }}>Acciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {pendientes.map((item, i) => {
                                            const esRechazado = item._aeatRechazado;
                                            const esParcial = item._parcialCorrecto;
                                            const esHistorico = (esRechazado || esParcial) && item._isLatestForBill === false;
                                            const displayStatus = esRechazado ? 'aeat_rechazado' : item.status;
                                            const errorMsg = esRechazado
                                                ? (item.result && item.result.errores ? item.result.errores.join('; ') : (item.result && item.result.descripcion) || '—')
                                                : esParcial
                                                    ? (item.result && item.result.errores && item.result.errores.length ? item.result.errores.join('; ') : 'Aceptado con avisos')
                                                    : (item.lastError || '—');
                                            const rowBg = esHistorico ? '#fdf7ff' : esRechazado ? '#fff5fb' : esParcial ? '#fffbeb' : (item.status === 'permanently_failed' ? '#fff7f7' : '#fff');
                                            return (
                                            <tr key={item._id} style={{ borderBottom: i < pendientes.length - 1 ? '1px solid #f3f4f6' : 'none', background: rowBg, opacity: esHistorico ? 0.7 : 1 }}>
                                                <td style={{ padding: '10px 16px' }}>
                                                    <StatusBadge status={displayStatus} />
                                                    {esHistorico && <span style={{ display: 'block', fontSize: '10px', color: '#9ca3af', marginTop: '2px' }}>intento previo</span>}
                                                </td>
                                                <td style={{ padding: '10px 16px', color: '#374151' }}>{item.operacion === 'alta' ? 'Alta' : 'Anulación'}</td>
                                                <td style={{ padding: '10px 16px' }}>
                                                    {item.billCode
                                                        ? <a href={`/edit_bill?bill_id=${item.billId}`} style={{ fontWeight: 600, color: '#2563eb', textDecoration: 'none' }}>{item.billCode}</a>
                                                        : <span style={{ fontFamily: 'monospace', fontSize: '11px', color: '#6b7280' }}>{String(item.billId)}</span>
                                                    }
                                                </td>
                                                <td style={{ padding: '10px 16px', color: '#374151' }}>{item.attempts}/{item.maxAttempts}</td>
                                                <td style={{ padding: '10px 16px', color: esParcial ? '#92400e' : '#dc2626', maxWidth: '220px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                                                    title={errorMsg}>
                                                    {errorMsg}
                                                </td>
                                                <td style={{ padding: '10px 16px', color: '#6b7280', fontSize: '12px' }}>
                                                    {this.formatDate(item.createdAt)}
                                                    {!esHistorico && (item.status === 'pending' || item.status === 'retrying') &&
                                                        <span style={{ display: 'block', fontSize: '10px' }}>Próximo: {this.formatDate(item.nextRetryAt)}</span>
                                                    }
                                                </td>
                                                <td style={{ padding: '10px 16px' }}>
                                                    <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                                                        {!item.billAnulada && (item.status === 'permanently_failed' || (esRechazado && item._isLatestForBill)) && (
                                                            <button className="btn btn-sm btn-warning"
                                                                style={{ borderRadius: '6px', fontSize: '12px', fontWeight: 600 }}
                                                                onClick={() => this.handleReencolar(item._id)}>
                                                                Reencolar
                                                            </button>
                                                        )}
                                                        {(esRechazado || esParcial || item.status === 'done' || item.status === 'permanently_failed') && (
                                                            <button className="btn btn-sm btn-outline-secondary"
                                                                style={{ borderRadius: '6px', fontSize: '12px' }}
                                                                onClick={() => this.handleVerXml(item._id)}>
                                                                Ver XML
                                                            </button>
                                                        )}
                                                    </div>
                                                </td>
                                            </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </>}
            </div>
        );
    }

    render() {
        const { activeTab } = this.state;

        const tabs = [
            { key: 'actividad', label: 'Actividad reciente' },
            { key: 'estado',    label: 'Estado y atención' },
        ];

        return (
            <div className="container-fluid">
                <Menu />
                <div style={{ maxWidth: '1200px', margin: '24px auto', padding: '0 12px' }}>

                    {/* Cabecera */}
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px', flexWrap: 'wrap', gap: '12px' }}>
                        <div>
                            <h3 style={{ margin: 0, fontWeight: 700, color: '#111827' }}>Administración Verifactu</h3>
                            <p style={{ margin: '4px 0 0', color: '#6b7280', fontSize: '14px' }}>Estado de la cola de envío a la AEAT</p>
                        </div>
                        <div style={{ display: 'flex', gap: '10px' }}>
                            <button className="btn btn-outline-secondary btn-sm" style={{ borderRadius: '6px' }}
                                onClick={() => { this.loadActividad(); if (activeTab === 'estado') this.loadDashboard(); }}>
                                ↻ Actualizar
                            </button>
                            <button className="btn btn-outline-warning btn-sm" style={{ borderRadius: '6px', fontWeight: 600 }}
                                onClick={() => this.setState({ envioManualOpen: true, envioManualXml: '', envioManualResult: null })}>
                                ✎ Envío manual XML
                            </button>
                            <button className="btn btn-primary btn-sm" style={{ borderRadius: '6px' }} onClick={this.handleFlush}>
                                ▶ Forzar procesado
                            </button>
                        </div>
                    </div>

                    {/* Pestañas */}
                    <div style={{ display: 'flex', gap: '0', borderBottom: '2px solid #e5e7eb', marginBottom: '24px' }}>
                        {tabs.map(tab => (
                            <button key={tab.key}
                                onClick={() => {
                                    this.setState({ activeTab: tab.key });
                                    if (tab.key === 'estado' && !this.state.stats) this.loadDashboard();
                                }}
                                style={{
                                    border: 'none', background: 'none', padding: '10px 20px', fontSize: '14px', fontWeight: 600,
                                    cursor: 'pointer', position: 'relative', bottom: '-2px',
                                    color: activeTab === tab.key ? '#2563eb' : '#6b7280',
                                    borderBottom: activeTab === tab.key ? '2px solid #2563eb' : '2px solid transparent',
                                }}>
                                {tab.label}
                            </button>
                        ))}
                    </div>

                    {/* Contenido de la pestaña activa */}
                    {activeTab === 'actividad' && this.renderActividadTab()}
                    {activeTab === 'estado'    && this.renderEstadoTab()}

                </div>

                {this.renderXmlModal()}
                {this.renderEnvioManualModal()}
                <Modal />
            </div>
        );
    }
}

const mapStateToProps = state => ({ menu: state.menu });
const mapDispatchToProps = dispatch => ({
    setModalContent(modalContent) { dispatch(setModalContent(modalContent)); }
});

export default connect(mapStateToProps, mapDispatchToProps)(VerifactuAdmin);
